<template>
  <div class="bill-list-circle">
    <el-table :data="billList">
      <el-table-column label="创建时间">
        <template slot-scope="scope">
          {{ scope.row.createTime | moment }}
        </template>
      </el-table-column>
      <el-table-column label="业务Id" prop="businessKey"></el-table-column>
      <el-table-column label="业务时间">
        <template slot-scope="scope">
          {{ scope.row.businessTime | moment }}
        </template>
      </el-table-column>
      <el-table-column label="业务类型">
        <template slot-scope="scope">
          {{
            (
              (billTypes &&
                billTypes.find(
                  item => scope.row.businessType === item.value
                )) ||
              {}
            ).label
          }}
        </template>
      </el-table-column>
      <el-table-column label="业务状态">
        <template slot-scope="scope">
          {{ statusType[scope.row.status].label }}
        </template>
      </el-table-column>
      <el-table-column label="更新时间">
        <template slot-scope="scope">
          {{ scope.row.updateTime | moment }}
        </template>
      </el-table-column>

      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.status === 2"
            type="primary"
            size="small"
            @click="reset(scope.row.id, scope.row.businessType)"
            >更新</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :total="totalCount"
      :page="pagination.page"
      @pageChanged="pageChanged"
    ></pagination>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import Pagination from 'components/pagination';

export default {
  data() {
    return {
      statusType: [
        { value: 0, label: '未处理' },
        { value: 1, label: '处理中' },
        { value: 2, label: '待人工处理' },
        { value: 3, label: '已处理' },
        { value: 4, label: '处理失败' }
      ]
    };
  },
  computed: {
    ...mapState('overtime', [
      'billList',
      'pagination',
      'totalCount',
      'billTypes'
    ])
  },
  methods: {
    ...mapMutations('overtime', ['setpage']),
    ...mapActions('overtime', ['getUserBillList', 'reRecharge', 'reReset']),
    pageChanged(pagination) {
      this.setpage(pagination);
      this.$emit('refresh', pagination);
    },
    reset(id, type) {
      this.$confirm('确认要进行该操作吗？', '提示', { type: 'warning' }).then(
        () => {
          this.reReset({ id: id, businessType: type })
            .then(() => {
              this.$message.success('操作成功！');
            })
            .finally(() => {
              this.$emit('refresh', this.pagination);
            });
        }
      );
    }
  },
  components: {
    Pagination
  }
};
</script>
<style>
.textover {
  word-break: keep-all;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
